const CHQuotes = () => {
	return (
		<>
			<path d="M14.45 24.97C7.57 24.97 2 19.39 2 12.52V5.40002H14.45V24.97Z" fill="#F7D9D8" />
			<path d="M29 24.97C22.12 24.97 16.55 19.39 16.55 12.52V5.40002H29V24.97Z" fill="#F7D9D8" />
		</>
	);
};

export default CHQuotes;
